var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('fullscreen-wait'),_c('alert-bar'),(!this.$online && false)?_c('v-system-bar',{staticClass:"black d-flex justify-center",attrs:{"dark":"","app":"","fixed":""}},[_vm._v(" Not connected to the internet, Working offline. ")]):_vm._e(),_c('v-main',[_c('router-view'),_c('about-snackbar')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }